.container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
  margin-bottom: 5px;
}

.banner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  background-color: var(--neutral4);

  .discount {
    font-size: 45px;
    font-weight: bold;
  }

  .title {
    font-size: 18px;
  }

  .button {
    background-color: var(--yellow1);
    width: 100%;
    border-radius: 13px;
    border: 0;
    padding: 6px 25px;
    margin-top: 25px;
    font-weight: bold;

    &:hover {
      filter: brightness(90%);
    }
  }

  &.fullPayment {
    background-color: var(--yellow1);

    .button {
      background-color: var(--dark);
      color: var(--white);

      &:hover {
        filter: brightness(90%);
      }
    }
  }
}

.content {
  text-align: center;
  margin-bottom: 30px;
}

.warning {
  font-size: 14px;
}
